import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import mainPhotoCatLeft from '@assets/images/home-cat-left.webp';
import mainPhotoCatRight from '@assets/images/home-cat-right.webp';



interface MainPhotoProps {
	scrollToCollar: () => void,
	scrollToProbe: () => void
}


const MainPhoto = (props: MainPhotoProps): JSX.Element => {
	const { scrollToCollar, scrollToProbe } = props;

	return (
		<div className='main-photo'>
			
			<div className='main-photo-text disable-selection cats-text' onClick={scrollToCollar}>
				<p>BEZPEČNÉ A POHODLNÉ<br />
					POOPERAČNÍ LÍMCE<br />
					PRO KOČKY</p>

				<Link to={NavigateRoutesEnum.catOrder} className='app-main-button cats-button'
					onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation() }}>
					CHCI&nbsp;OBJEDNAT
				</Link>
			</div>

			<div className='main-photo-text disable-selection cats-text' onClick={scrollToProbe}>
				<p>GASTRO límec<br />
					PRO KOČKY</p>

				<Link to={NavigateRoutesEnum.partners} className='app-main-button cats-button'
					onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation() }}>
					CHCI&nbsp;OBJEDNAT
				</Link>
			</div>
			
			<div className='main-photo-image-cats'>
				<img src={mainPhotoCatLeft} alt='main-content-photo' />
				<img src={mainPhotoCatRight} alt='main-content-photo' />
			</div>
		
		</div>
	);
};

export default MainPhoto;